import { Url } from "../types";
import { AsyncJobMessage, AsyncJobProgress, Job, StoredJob } from "./asyncJobs";

type ImportExportJobStatus =
  | "completed"
  | "created"
  | "failed"
  | "processing"
  | "uploaded";

export type ImportExportMetadata = {
  includedModules:
    | ["assets"]
    | ["systems"]
    | ["assets", "systems"]
    | ["categories", "status_sets", "custom_attributes"];
  channelId?: string;
  progress?: AsyncJobProgress;
};

export interface ImportJob extends Job {
  jobType: "import";
  status: ImportExportJobStatus;
  metadata: ImportExportMetadata;
}

export interface StoredImportJob extends StoredJob {
  jobType: "import";
  status: ImportExportJobStatus;
  metadata: ImportExportMetadata;
  importType: "assets" | "projectSettings";
}

export interface ExportJob extends Job {
  jobType: "export";
  status: ImportExportJobStatus;
  metadata: ImportExportMetadata;
}

export interface AssetExportMessage extends AsyncJobMessage {
  status: ImportExportJobStatus;
  signedUrl?: Url;
}

export interface AssetImportMessage extends AsyncJobMessage {
  status: ImportExportJobStatus;
}

export type ExportResponse = {
  signedUrl: string;
};

export const exportFileFormats = ["csv", "xlsx"] as const;
export type ExportFileFormat = (typeof exportFileFormats)[number];

export const reportNames = ["ASSET_DETAIL_CSV", "ASSET_DETAIL_XLSX"] as const;
export type ReportName = (typeof reportNames)[number];

export const reports: Record<ReportName, { format: ExportFileFormat }> = {
  ASSET_DETAIL_CSV: {
    format: "csv",
  },
  ASSET_DETAIL_XLSX: {
    format: "xlsx",
  },
};

export type ImportFileErrors = {
  tooManyFiles: boolean;
  fileTooLarge: boolean;
  badFileExtension: boolean;
  unknownError: boolean;
};

export type AssetExportTypes = "csvOrXlsx" | "pdf";
